import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import ImageDisplay from '../imageDisplay';
import { BLOCKS } from '@contentful/rich-text-types';

import { mapCard } from '../../utils/mappers';

const optionsSubtleBig = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node) =>
			node.content.map((item, index) => (
				<p key={index} className="typography typography--subtle-big">
					{item.value}
				</p>
			)),
	},
};

const optionsBodyBig = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node) =>
			node.content.map((item, index) => (
				<p
					key={index}
					className="typography typography--body-big typography--white"
				>
					{item.value}
				</p>
			)),
	},
};

const palette = ['secondary', 'blue-gray', 'rose'];

const BookToday = ({ groupingTitle, groupingDescription, promoCards }) => {
	return (
		<div className="book-today section">
			<div className="section__content">
				<div className="book-today__body">
					<h2 className="typography typography--h2 typography--secondary">
						{groupingTitle}
					</h2>
					{groupingDescription && (
						<div>{renderRichText(groupingDescription, optionsSubtleBig)}</div>
					)}
				</div>
				<div className="book-today__items">
					{promoCards?.map(mapCard).map((card, index) => (
						<div
							key={card.title}
							className={`book-today__item bg--${palette[index]}`}
						>
							<figure className="book-today__item-icon">
								<ImageDisplay
									alt={card.desktopIcon?.alt}
									image={card.desktopIcon?.data}
									src={card.desktopIcon?.src}
								/>
							</figure>
							<h3 className="book-today__item-title typography typography--h3 typography--white">
								{card.title}
							</h3>
							<div>{card.description && renderRichText(card.description, optionsBodyBig)}</div>
							<Link
								to={card.cta.link}
								className="book-today__item-button btn btn--bottom"
							>
								{card.cta.title}
							</Link>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

BookToday.propTypes = {
	groupingTitle: PropTypes.string.isRequired,
	groupingDescription: PropTypes.shape({
		raw: PropTypes.string,
	}),
	promoCards: PropTypes.arrayOf(
		PropTypes.shape({
			desktopIcon: PropTypes.shape({
				gatsbyImageData: PropTypes.object,
				file: PropTypes.shape({ url: PropTypes.string }),
				description: PropTypes.string,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.shape({
				raw: PropTypes.string,
			}),
		})
	).isRequired,
};

export default BookToday;
